import type { FeatureFlag } from "@/config/feature-flags";
import { userStore } from "@/store/user-store";
import { type IUser, useFeatureFlag } from "configcat-react";

export function useAppFeatureFlag(key: FeatureFlag, defaultValue = false): { value: boolean; loading: boolean } {
  const user = userStore((state) => state.user);
  const configCatUser: IUser | undefined = user ? { identifier: user.uuid, email: user.email } : undefined;

  return useFeatureFlag(key, defaultValue, configCatUser);
}
